import Banner from "../../sections/common/banner";
import SectionClients2 from "../../sections/home/index2/section-clients2";
import ItodoImage from "../../elements/itodo-img";
import { NavLink } from "react-router-dom";
import { bannerData } from "../../../globals/banner";
import { blogPosts } from "../../../globals/neuron-content";

function InsightsGridPage() {
  return (
    <>
      <Banner _data={bannerData.insights} />

      <div className="section-full p-t100 p-b0 bg-white mobile-page-padding">
        <div className="container">
          <div className="masonry-outer mfp-gallery news-grid clearfix row">
            {blogPosts.map((post) => (
              <div key={post.title} className="masonry-item col-lg-4 col-md-6 col-sm-12 m-b30">
                <div className="sx-latest-post-st-1">
                  <div className="sx-post-media sx-img-effect img-reflection">
                    <NavLink to={`/insights/${post.slug}`}><ItodoImage src={post.image} alt={post.title} /></NavLink>
                  </div>
                  <div className="sx-post-info p-t30">
                    <div className="sx-post-meta">
                      <ul>
                        <li className="post-date"><NavLink to={`/insights/${post.slug}`}><i className="fa fa-calendar" />{post.date}</NavLink></li>
                        <li className="post-author"><NavLink to={`/insights/${post.slug}`}><i className="fa fa-comments" />{post.comments} Comments</NavLink></li>
                      </ul>
                    </div>
                    <div className="sx-post-title"><h4 className="post-title"><NavLink to={`/insights/${post.slug}`}>{post.title}</NavLink></h4></div>
                    <p>{post.summary}</p>
                    <div className="sx-post-readmore"><NavLink to={`/insights/${post.slug}`} title="READ MORE" rel="bookmark" className="site-button icon"><i className="fa fa-long-arrow-right" />Read More</NavLink></div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <SectionClients2 hideTitle={true} />
    </>
  );
}

export default InsightsGridPage;
